import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/sections/Hero";
import Idea from "@/sections/Idea";
import WhoFor from "@/sections/WhoFor";
import Method from "@/sections/Method";
import Offerings from "@/sections/Offerings";
import QuotesStrip from "@/sections/QuotesStrip";
import Testimonials from "@/sections/Testimonials";
import AboutTeaser from "@/sections/AboutTeaser";
import InstagramStrip from "@/sections/InstagramStrip";
import LettersTeaser from "@/sections/LettersTeaser";
import LeadMagnet from "@/sections/LeadMagnet";
import ContactSection from "@/sections/ContactSection";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 250);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Idea />
      <WhoFor />
      <Method />
      <Offerings />
      <QuotesStrip />
      <Testimonials />
      <AboutTeaser />
      <InstagramStrip />
      <LettersTeaser />
      <LeadMagnet />
      <ContactSection />
    </main>
  );
}
